<template>
  <v-card class="dashboard-item" flat @click="$router.push({ name: routeNames.activity_reservations.name })">
    <v-layout justify-center align-center fill-height column>
      <v-chip class="light-background primary--text text--lighten-1 interactive-chip">
        <span class="mr-2">{{ $t('activity_reservation.actions.see_all') }}</span>
        <v-icon size="22" color="primary lighten-1 material-symbols-rounded">arrow_forward</v-icon>
      </v-chip>
    </v-layout>
  </v-card>
</template>
<script>
import routeNames from '@/router/routes'
export default {
  data () {
    return {
      routeNames,
    }
  },
}
</script>

<style lang="scss" scoped>
.dashboard-item {
  border: 2px solid var(--v-primary-lighten1);
  width: 210px;
  height: 173px;
  border-radius: 10px;
}
</style>